export default __webpack_public_path__ + "static/media/super-excited.02b80593.svg";